import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeqLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "euCt29XgmPK1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 35 35",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	"project-id": "af83da4d8be94dc1b626b2c82fa8f3a2",
	"export-id": "c733ae14c51b497e8499d567d4e8482d",
	cached: "false",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: "\r\n#euCt29XgmPK5 {animation: euCt29XgmPK5_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK5_f_p { 0% {fill: #d5d9eb} 50% {fill: #d5d9eb} 58.333333% {fill: #3e4784} 100% {fill: #3e4784}} #euCt29XgmPK6 {animation: euCt29XgmPK6_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK6_f_p { 0% {fill: #d5d9eb} 33.333333% {fill: #d5d9eb} 41.666667% {fill: #717bbc} 100% {fill: #717bbc}} #euCt29XgmPK7 {animation: euCt29XgmPK7_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK7_f_p { 0% {fill: #d5d9eb} 41.666667% {fill: #d5d9eb} 50% {fill: #4e5ba6} 100% {fill: #4e5ba6}} #euCt29XgmPK8 {animation: euCt29XgmPK8_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK8_f_p { 0% {fill: #d5d9eb} 25% {fill: #d5d9eb} 33.333333% {fill: #b3b8db} 100% {fill: #b3b8db}} #euCt29XgmPK9 {animation: euCt29XgmPK9_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK9_f_p { 0% {fill: #d5d9eb} 16.666667% {fill: #d5d9eb} 25% {fill: #cdd1e4} 100% {fill: #cdd1e4}} #euCt29XgmPK10 {animation: euCt29XgmPK10_f_p 1200ms linear infinite normal backwards}@keyframes euCt29XgmPK10_f_p { 0% {fill: #e3e7fa} 8.333333% {fill: #e3e7fa} 16.666667% {fill: #d5d9eb} 100% {fill: #d5d9eb}}\r\n" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "euCt29XgmPK3-filter",
			x: "-150%",
			width: "400%",
			y: "-150%",
			height: "400%",
			children: [
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					id: "euCt29XgmPK3-filter-drop-shadow-0-blur",
					in: "SourceAlpha",
					stdDeviation: "0,0"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					id: "euCt29XgmPK3-filter-drop-shadow-0-offset",
					dx: 0,
					dy: 0,
					result: "tmp"
				}),
				/* @__PURE__ */ _jsx("feFlood", {
					id: "euCt29XgmPK3-filter-drop-shadow-0-flood",
					floodColor: "#000"
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					id: "euCt29XgmPK3-filter-drop-shadow-0-composite",
					operator: "in",
					in2: "tmp"
				}),
				/* @__PURE__ */ _jsxs("feMerge", {
					id: "euCt29XgmPK3-filter-drop-shadow-0-merge",
					result: "result",
					children: [/* @__PURE__ */ _jsx("feMergeNode", { id: "euCt29XgmPK3-filter-drop-shadow-0-merge-node-1" }), /* @__PURE__ */ _jsx("feMergeNode", {
						id: "euCt29XgmPK3-filter-drop-shadow-0-merge-node-2",
						in: "SourceGraphic"
					})]
				})
			]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(-377.594879-176.923172)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "matrix(.313881-.001463 0.001463 0.313881 252.573505 133.483252)",
				filter: "url(#euCt29XgmPK3-filter)",
				children: [/* @__PURE__ */ _jsxs("g", {
					transform: "matrix(-1 0 0-1 951.228578 435.68399)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK5",
							d: "M440.09,193.744c-.432.004-.854-.121-1.215-.357-.36-.236-.641-.573-.807-.968-.167-.395-.211-.831-.128-1.251s.291-.806.596-1.109l12.429-12.337c.412-.409.971-.639,1.554-.639.288,0,.574.056.84.166.267.109.509.27.713.473.204.202.366.442.477.707.11.265.167.548.167.835c0,.286-.057.57-.167.834-.111.265-.273.505-.477.708l-12.429,12.337c-.206.198-.449.352-.716.456-.266.103-.551.152-.837.145Z",
							transform: "translate(10.179979 12.499113)",
							fill: "#d5d9eb"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK6",
							d: "M467.433,191.894c-.288-.003-.574.051-.841.16s-.509.269-.712.472l-12.429,12.337c-.412.409-.644.964-.644,1.543c0,.578.232,1.133.644,1.542s.971.638,1.553.638c.583,0,1.142-.229,1.554-.638l12.429-12.338c.305-.302.512-.689.596-1.109.083-.42.039-.855-.128-1.251-.166-.395-.447-.732-.807-.968-.361-.236-.783-.36-1.215-.357",
							transform: "translate(11.153594 14.349882)",
							fill: "#d5d9eb"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK7",
							d: "M459.96,183.492c-.288-.003-.574.052-.841.16-.267.109-.509.269-.713.472l-12.428,12.338c-.412.409-.644.963-.644,1.542c0,.578.232,1.133.644,1.542s.97.639,1.553.639s1.142-.23,1.554-.639l12.429-12.337c.305-.303.512-.689.596-1.11.083-.42.039-.855-.128-1.25-.166-.396-.447-.733-.808-.969-.36-.236-.782-.36-1.214-.357",
							transform: "translate(11.154261 14.206742)",
							fill: "#d5d9eb"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK8",
							d: "M474.891,198.297c-.288-.002-.574.052-.841.161s-.509.269-.713.471l-12.429,12.337c-.204.203-.366.443-.476.708-.11.264-.167.548-.167.834c0,.287.057.57.167.835s.272.505.476.707c.204.203.447.364.713.473.267.11.552.166.841.166.288,0,.574-.056.841-.166.266-.109.509-.27.713-.473l12.428-12.337c.306-.303.513-.689.597-1.109.083-.42.039-.856-.128-1.251-.166-.395-.448-.732-.808-.968s-.783-.361-1.214-.357",
							transform: "translate(11.153594 16.292882)",
							fill: "#d5d9eb"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK9",
							d: "M482.348,205.699c-.288-.003-.575.051-.841.16-.267.109-.509.269-.713.472l-12.429,12.337c-.412.409-.643.964-.643,1.542c0,.579.231,1.134.643,1.543s.971.638,1.554.638s1.142-.229,1.554-.638l12.429-12.338c.305-.302.512-.689.596-1.109.083-.42.039-.856-.128-1.251-.166-.395-.448-.732-.808-.968s-.783-.36-1.214-.357",
							transform: "translate(11.153594 16.292882)",
							fill: "#d5d9eb"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "euCt29XgmPK10",
							d: "M489.805,213.117c-.288-.003-.574.051-.841.16-.267.108-.509.269-.713.472l-12.428,12.337c-.412.409-.644.964-.644,1.542c0,.579.232,1.133.644,1.542s.97.639,1.553.639s1.142-.23,1.554-.639l12.429-12.337c.305-.303.512-.689.596-1.109.083-.42.039-.856-.128-1.251-.166-.395-.447-.732-.808-.968-.36-.236-.782-.361-1.214-.358",
							transform: "translate(11.153594 16.292882)",
							fill: "#e3e7fa"
						})
					]
				}), /* @__PURE__ */ _jsx("path", {
					d: "M466.92,130.133h-49.063c-6.631.008-12.989,2.627-17.678,7.281-4.689,4.655-7.327,10.965-7.335,17.548v48.639c.008,6.583,2.646,12.893,7.335,17.548c4.689,4.654,11.047,7.273,17.678,7.281h39.462c.809.009,1.6-.239,2.257-.708s1.145-1.134,1.394-1.898c.155-.524.161-1.081.019-1.609-.143-.527-.429-1.006-.827-1.383l-10.611-10.533c-.397-.407-.904-.691-1.461-.817-.352-.072-.712-.108-1.072-.108h-21.983c-1.973-.002-3.926-.39-5.748-1.141-1.822-.752-3.477-1.852-4.871-3.238s-2.498-3.031-3.252-4.841c-.753-1.81-1.139-3.75-1.137-5.708v-34.436c0-3.953,1.58-7.744,4.395-10.54c2.814-2.796,6.631-4.369,10.613-4.373h31.569c4.809,0,9.42,1.896,12.82,5.271c3.401,3.375,5.311,7.953,5.311,12.726v18.737c0,.357.036.714.109,1.064.126.552.412,1.056.823,1.45l10.611,10.533c.38.395.862.679,1.394.82.531.142,1.092.135,1.62-.018.77-.247,1.44-.732,1.913-1.384.472-.652.722-1.437.713-2.241v-39.155c-.025-6.569-2.668-12.861-7.352-17.502s-11.028-7.253-17.646-7.265Z",
					transform: "translate(11.153594 16.292882)",
					fill: "#d5d9eb"
				})]
			})
		})
	]
});
export default SvgMeqLoading;
